export default __webpack_public_path__ + "images/empty-box-bitiba.png";